// extracted by mini-css-extract-plugin
export default {"cancellationItem":"styles_cancellationItem__nBYbW"};